UtilsService.$inject = [];

function UtilsService() {

}

/**
 * @desc Checks if a string is a valid email address
 *  @param {String} str
 * @return Boolean
 */
UtilsService.prototype.isEmail = function (str) {
  return str.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
};

UtilsService.prototype.replaceAll = function (string, find, replace) {
  return string.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};

UtilsService.prototype.generateGuid = guid;

function escapeRegExp(string) {
  return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"); //eslint-disable-line
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4(); //eslint-disable-line
}

export default UtilsService;



// WEBPACK FOOTER //
// ./src/services/utilsService.js